import {
  BUSINESS_SOLUTION_ORGANIZATION_ID,
  GRUSHKA_ORGANIZATION_ID,
} from '@app/access/constants/organizations';
import { config } from '@app/config';

export const getDocumentFlowAccess = (database: string | null) => {
  const { mode } = config;

  if (mode !== 'production') {
    return true;
  }

  return (
    database === GRUSHKA_ORGANIZATION_ID ||
    database === BUSINESS_SOLUTION_ORGANIZATION_ID
  );
};
